/* eslint-disable no-underscore-dangle */
/* eslint-disable no-unused-expressions */

import { useState } from "react";
import { useSelector, useDispatch } from "react-redux";

// @mui material components
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import Icon from "@mui/material/Icon";
import MDButton from "components/Basics/MDButton";

import i18n from "i18n";
import { Card, CardContent, Checkbox, IconButton, Menu, MenuItem, Tooltip } from "@mui/material";
import lod_ from "lodash";

// Material Dashboard 2 PRO React components
import MDBadge from "components/Basics/MDBadge";
import MDBox from "components/Basics/MDBox";
import MDTypography from "components/Basics/MDTypography";
import ConfirmDialogButton from "components/Custom/Dialogs/ConfirmDialogButton";

import { selectUser } from "redux-react/reducers/userReducers";
import { getPermissions } from "redux-react/reducers/permissionsReducer";
import SettingsActions from "redux-react/actions/settingsActions";
import { display as displayItem } from "redux-react/reducers/snackBarReducer";

// Material Dashboard 2 PRO React examples
import DataTableHeadCell from "./DataTableHeadCell";
import DataTableBodyCell from "./DataTableBodyCell";

/**
 * ##############################
 * Handle specials actions in props
 * -> allow to custom actions with row values
 * e.g : disabe, click, loadingn style
 * ##############################
 */
function overrideObjectProps(action, row) {
	// custom disabled method
	const checkDisabled = act => {
		if (act.props?.disabled) {
			return act.props.disabled;
		} else if (act.props?.customdisabled) {
			return act.props.customdisabled(row);
		} else {
			return false;
		}
	};
	// custom style
	const customStyle = act => {
		let style = act.props?.style ?? {};
		if (act.props?.customstyle) {
			style = act.props.customstyle(row, style);
		}
		return style;
	};

	const customLoading = act => {
		if (act.props?.loading) {
			let loadingObject = act.props.loading(row);
			if (loadingObject.loading) {
				return loadingObject.component;
			}
		}
		return act.props?.children;
	};

	action = {
		...action,
		props: {
			...action.props,
			onClick(e) {
				action.props?.handleclick ? action.props?.handleclick(row, e) : null;
			},
			disabled: checkDisabled(action),
			style: customStyle(action),
			children: customLoading(action)
		}
	};

	if (action.props.children && lod_.isObject(action.props.children)) {
		action.props.children = overrideObjectProps(action.props.children, row);
	}

	return action;
}

const Row = ({
	dictionaryCode,
	index,
	object,
	display,
	layer,
	editionMode,
	actions,
	dictionaryFormat,
	handleAddRow
}) => {
	const [open, setOpen] = useState(false);
	const [menu, setMenu] = useState(null);
	const user = useSelector(selectUser);

	const openMenu = e => {
		setMenu(e.currentTarget);
		e.stopPropagation();
	};

	const closeMenu = () => setMenu(null);

	const handleClickMenuItem = datas => {
		handleAddRow(datas);
		closeMenu();
	};

	const renderAddMenu = () => {
		return (
			<Menu
				className="addMenu"
				anchorEl={menu}
				open={Boolean(menu)}
				onClose={closeMenu}
				anchorOrigin={{
					vertical: "center",
					horizontal: "right"
				}}
				transformOrigin={{
					vertical: "center",
					horizontal: "left"
				}}
			>
				{/* Add item in the object, parent is the row */}
				{object.type === "level" && (
					<MenuItem
						onClick={() => {
							let datas = {
								codeDictionary: dictionaryCode,
								parent: object._id,
								order: object.items ? Object.keys(object.items).length : 0,
								active: true
							};
							handleClickMenuItem(datas);
						}}
					>
						<Icon>subdirectory_arrow_right</Icon>
						<MDBox
							sx={{
								ml: 1
							}}
						>
							<MDTypography variant="button" fontWeight="regular">{`${i18n.t(
								"SETTINGS.DICTIONARY.addIn"
							)} ${object?.label?.fr}`}</MDTypography>
						</MDBox>
					</MenuItem>
				)}
				{/* Add item after this row, parent is the same, only for layer > 1 */}
				{layer > 1 && (
					<MenuItem
						onClick={() => {
							let datas = {
								codeDictionary: dictionaryCode,
								parent: object.parent,
								order: object.order + 1,
								active: true
							};
							handleClickMenuItem(datas);
						}}
					>
						<Icon>add</Icon>
						<MDBox
							sx={{
								ml: 1
							}}
						>
							<MDTypography variant="button" fontWeight="regular">{`${i18n.t(
								"SETTINGS.DICTIONARY.addAfter"
							)} ${object?.label?.fr}`}</MDTypography>
						</MDBox>
					</MenuItem>
				)}
			</Menu>
		);
	};

	return (
		<>
			{/* Add menu */}
			{renderAddMenu()}
			{/* Main component */}
			<TableRow
				onClick={() => {
					setOpen(!open);
				}}
				className={object.items ? "dictionaryRowClickable dictionaryRow" : "dictionaryRow"}
			>
				{/* Add row */}
				{editionMode && (
					<DataTableBodyCell>
						<Tooltip placement="top" title={i18n.t("SETTINGS.DICTIONARY.addAField")}>
							<IconButton onClick={openMenu}>
								<Icon fontSize="medium">add</Icon>
							</IconButton>
						</Tooltip>
					</DataTableBodyCell>
				)}
				{/* Icons & name */}
				<DataTableBodyCell
					style={{
						paddingLeft: layer * 2 + "rem"
					}}
				>
					<MDBox display="flex" flexDirection="row" alignItems="center">
						<MDBox display="flex" flexDirection="row" alignItems="center">
							{object.type === "level" &&
								(open ? (
									<Icon fontSize="medium">keyboard_arrow_down</Icon>
								) : (
									<Icon fontSize="medium">keyboard_arrow_right</Icon>
								))}
							{object.type !== "level" &&
								(object.system ? (
									<Tooltip placement="top" title="Donnée système">
										<Icon fontSize="medium">admin_panel_settings</Icon>
									</Tooltip>
								) : (
									<Icon fontSize="medium">article</Icon>
								))}
						</MDBox>
						<MDBox sx={{ pl: 2 }} /* display="flex" flexDirection="row" alignItems="center" */>
							<MDTypography fontSize="small">{object?.label?.fr}</MDTypography>
							<MDTypography
								/* sx={{ ml: 1 }} */ variant="caption"
							>{`${object?.code}`}</MDTypography>
						</MDBox>
					</MDBox>
				</DataTableBodyCell>
				{/* All columns */}
				{display.map((column, index) => {
					/* Code */
					if (column === "code") return null;
					/* Boolean */
					let dictionaryItem = (dictionaryFormat?.items || {})[column];

					if (dictionaryItem && dictionaryItem?.type === "boolean") {
						return (
							<DataTableBodyCell key={index}>
								<Checkbox disabled checked={lod_.get(object, column)} />
							</DataTableBodyCell>
						);
					}
					/* Objects */
					if (lod_.isObject(lod_.get(object, column))) {
						return (
							<DataTableBodyCell key={index}>
								<table>
									{Object.keys(lod_.get(object, column)).map((key, index) => {
										return (
											<tr>
												<td className="listKeyStyle">{key}</td>
												<td className="grid-item">{lod_.get(object, column)[key]}</td>
											</tr>
										);
									})}
								</table>
							</DataTableBodyCell>
						);
					}
					/* Default */
					return <DataTableBodyCell key={index}>{lod_.get(object, column)}</DataTableBodyCell>;
				})}
				{/* Actions */}
				{editionMode && (
					<DataTableBodyCell>
						{/* {object.system !== true || user?.system === true ? ( */}
						<MDBox display="flex" justifyContent="flex-end">
							{actions.map((action, index) => {
								let overrideAction = overrideObjectProps(action, object);
								return <span key={index}>{overrideAction}</span>;
							})}
						</MDBox>
						{/* ) : null} */}
					</DataTableBodyCell>
				)}
			</TableRow>
			{/* Map items */}
			{object.items && open && (
				<DictionaryContent
					dictionaryCode={dictionaryCode}
					dictionary={object.items}
					display={display}
					layer={layer + 1}
					editionMode={editionMode}
					actions={actions}
					dictionaryFormat={dictionaryFormat}
					handleAddRow={handleAddRow}
				/>
			)}
		</>
	);
};

const DictionaryContent = ({
	dictionaryCode,
	dictionaryFormat,
	dictionary,
	display,
	layer = 1,
	editionMode,
	actions,
	handleAddRow
}) => {
	if (lod_.isEmpty(dictionary)) {
		return (
			<TableRow>
				<td colSpan={display.length + 2}>
					{editionMode && layer === 1 ? (
						<MDBox display="flex" justifyContent="center" mt={2}>
							<MDButton
								size="small"
								display="flex"
								color="info"
								onClick={() => {
									handleAddRow({
										codeDictionary: dictionaryCode,
										parent: "root",
										order: 0,
										active: true
									});
								}}
							>
								<Icon>add</Icon>&nbsp;{i18n.t("SETTINGS.add")}
							</MDButton>
						</MDBox>
					) : (
						<MDBox display="flex" justifyContent="center" mt={2}>
							<MDTypography variant="caption">{i18n.t("SETTINGS.DICTIONARY.noData")}</MDTypography>
						</MDBox>
					)}
				</td>
			</TableRow>
		);
	}

	return Object.keys(dictionary).map((key, index) => {
		let array = [];
		let value = dictionary[key];

		array.push(
			<Row
				dictionaryCode={dictionaryCode}
				index={index}
				object={value}
				display={display}
				layer={layer}
				editionMode={editionMode}
				actions={actions}
				dictionaryFormat={dictionaryFormat}
				handleAddRow={handleAddRow}
			/>
		);
		return array;
	});
};

function DictionaryDataTable({
	code,

	chart, // Full chart object

	display,
	dictionaryCode,
	dictionary,
	title,

	actions = [],
	dictionaryFormat,

	handleAddRow = () => {}, // Add a row
	deleteRow = () => {}, // Delete a row

	catalogs = [], // Possible catalogs
	catalog = null, // Possible catalog
	catalogCode = null, // Possible catalog code stored in the chart (request.catalog)

	changeDictionaryCatalog = () => {} // Change the catalog of the dictionary
}) {
	const dispatch = useDispatch();
	const { permissions } = useSelector(getPermissions);
	const hasAdminPermission = permissions.includes("access:accountSystem");

	const [editionMode, setEditionMode] = useState(false);

	const [catalogMenu, setCatalogMenu] = useState(null);

	return (
		<Card>
			<CardContent>
				<MDBox
					display="flex"
					flexDirection="row"
					alignItems="center"
					justifyContent="space-between"
					mb={2}
				>
					<MDBox>
						<MDBox display="flex" flexDirection="row" alignItems="center">
							<MDTypography variant="h6">{title}</MDTypography>
							<MDTypography variant="body2" sx={{ ml: 1 }}>{`(${dictionaryCode})`}</MDTypography>
						</MDBox>
						<MDTypography variant="body2" fontSize="small">
							{chart?.display?.description ?? "Aucune description"}
						</MDTypography>
					</MDBox>
					<MDBox>
						<MDBox display="flex" alignItems="center">
							{/* Catalog badge */}
							{/* Catalog not found */}
							{lod_.isEmpty(catalog) && !lod_.isNil(catalogCode) && hasAdminPermission && (
								<Tooltip
									placement="top"
									title={
										<div>
											Catalog <b>{catalogCode}</b> not found
										</div>
									}
								>
									<MDBadge
										sx={{ ml: 1 }}
										badgeContent={
											<MDBox display="flex" flexDirection="row" alignItems="center">
												<MDTypography variant="body2" fontWeight="bold" fontSize="small">
													{catalogCode}
												</MDTypography>
												{editionMode && <Icon fontSize="md">arrow_drop_down</Icon>}
											</MDBox>
										}
										variant="contained"
										color="error"
										size="xs"
										container
										style={editionMode ? { cursor: "pointer" } : {}}
										onClick={e => {
											if (!editionMode) return;
											setCatalogMenu(e.currentTarget);
										}}
									/>
								</Tooltip>
							)}
							{/* Catalog found */}
							{!lod_.isEmpty(catalog) && hasAdminPermission && (
								<Tooltip
									placement="top"
									title={
										<div style={{ textAlign: "left" }}>
											<b
												style={{
													marginRight: "5px"
												}}
											>
												Catalog:
											</b>
											{catalog.code}
											<hr
												style={{
													margin: "5px 0"
												}}
											/>
											<b
												style={{
													marginRight: "5px"
												}}
											>
												Cluster:
											</b>
											{catalog.clusterCode}
											<br />
											<b
												style={{
													marginRight: "5px"
												}}
											>
												DB:
											</b>
											{catalog.databaseName}
											<br />
											<b
												style={{
													marginRight: "5px"
												}}
											>
												Collection:
											</b>
											dictionary
										</div>
									}
								>
									<MDBadge
										sx={{ ml: 1 }}
										badgeContent={
											<MDBox display="flex" flexDirection="row" alignItems="center">
												<MDTypography variant="body2" fontWeight="bold" fontSize="small">
													{catalog.name}
												</MDTypography>
												{editionMode && <Icon fontSize="md">arrow_drop_down</Icon>}
											</MDBox>
										}
										variant="contained"
										color="info"
										size="xs"
										container
										style={editionMode ? { cursor: "pointer" } : {}}
										onClick={e => {
											if (!editionMode) return;
											setCatalogMenu(e.currentTarget);
										}}
									/>
								</Tooltip>
							)}
							<Menu
								anchorEl={catalogMenu}
								open={Boolean(catalogMenu)}
								onClose={() => setCatalogMenu(null)}
							>
								{catalogs.map((catalog, index) => {
									return (
										<MenuItem
											key={index}
											onClick={() => {
												setCatalogMenu(null);
												changeDictionaryCatalog(code, catalog);
											}}
										>
											{catalog.name}
										</MenuItem>
									);
								})}
							</Menu>
							{/* If user is admin, he can delete the dictionary */}
							{hasAdminPermission && (
								<ConfirmDialogButton
									onConfirm={(e, values) => {
										deleteRow(dictionaryCode);
									}}
									component={
										<IconButton onClick={() => {}}>
											<Tooltip placement="top" title="Supprimer le dictionnaire">
												<Icon>delete</Icon>
											</Tooltip>
										</IconButton>
									}
									rowValues={{
										title
									}}
									displayAttribute="title"
								/>
							)}
							{/* Copy to clipboard object dictionary */}
							<Tooltip
								placement="top"
								title={i18n.t("SETTINGS.DICTIONARY.copyToClipboard")}
								onClick={() => {
									dispatch(
										SettingsActions.copyDictionary(
											dictionaryCode,
											res => {
												const items = res?.items ?? [];
												navigator.clipboard.writeText(JSON.stringify(items, null, 2));
												dispatch(
													displayItem({
														type: "success",
														message: "Dictionary copied to clipboard successfully"
													})
												);
											},
											() => {
												dispatch(
													displayItem({
														type: "error",
														message: "Error while copying dictionary to clipboard"
													})
												);
											}
										)
									);
								}}
							>
								<IconButton>
									<Icon>content_copy</Icon>
								</IconButton>
							</Tooltip>
							{/* Turn on/off edit mode */}
							<Tooltip
								placement="top"
								title={
									!editionMode
										? i18n.t("SETTINGS.DICTIONARY.unlockEdition")
										: i18n.t("SETTINGS.DICTIONARY.lockEdition")
								}
							>
								<IconButton onClick={() => setEditionMode(!editionMode)}>
									{!editionMode ? <Icon>edit</Icon> : <Icon>edit_off</Icon>}
								</IconButton>
							</Tooltip>
						</MDBox>
					</MDBox>
				</MDBox>
				<TableContainer sx={{ boxShadow: "none" }}>
					<Table>
						<TableRow>
							{/* Add row */}
							{editionMode && <DataTableHeadCell align="left" sorted={false}></DataTableHeadCell>}
							{/* Empty cell for icons & code */}
							<DataTableHeadCell align="right" sorted={false}></DataTableHeadCell>
							{/* Map all other rows */}
							{display.map((column, index) => {
								if (column === "code") return null;
								let itemDictionary = lod_.get(
									dictionaryFormat.items,
									column.replaceAll(".", ".items.")
								);
								let label = column;
								try {
									let itemLabels = itemDictionary.label;
									label = itemLabels[Object.keys(itemLabels)[0]];
								} catch {
									// Do nothing
								}

								return (
									<DataTableHeadCell key={index} align="left" sorted={false}>
										{column !== "code" ? label : null}
									</DataTableHeadCell>
								);
							})}
							{/* Actions */}
							{editionMode && (
								<DataTableHeadCell width={20} align="right" sorted={false}></DataTableHeadCell>
							)}
						</TableRow>
						<TableBody>
							<DictionaryContent
								dictionaryCode={dictionaryCode}
								dictionary={dictionary}
								dictionaryFormat={dictionaryFormat}
								display={display}
								editionMode={editionMode}
								actions={actions}
								handleAddRow={handleAddRow}
							/>
						</TableBody>
					</Table>
				</TableContainer>
			</CardContent>
		</Card>
	);
}
export default DictionaryDataTable;
